import React, { useEffect } from "react";
import { Toaster } from "sonner";
import AppRoutes from "./routes/appRoutes";
import { useAppContext } from "./services/context";
import OneSignal from "react-onesignal";
import { onesignal_app_id } from "./services/axios/eps";
import InitializeOneSignal from "./Components/onesignalInitialization";

function App() {
  const { state, setState } = useAppContext();
  const { onesignalInitialized } = state;

  return (
    <>
      <InitializeOneSignal />
      <Toaster richColors={true} closeButton={true} position="top-center" />
      <AppRoutes />
    </>
  );
}

export default App;
